import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { WelcomeOverlayComponent } from './welcome-overlay/welcome-overlay.component';
import { ChangelogComponent } from './changelog/changelog.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { version } from 'src/changelog';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(public dialog: MatDialog) {}

  ngOnInit() {
    // If the version in localStorage, doesn't match the current version
    // And the user isn't a first time user, open the changelog
    if(localStorage.version != String(version) && localStorage.firstTimeUser == 'true') {
      this.dialog.open(ChangelogComponent, {
        width: '500px'
      })
      localStorage.setItem('version', String(version));
    }

    if(localStorage.firstTimeUser != 'true') {
      this.dialog.open(WelcomeOverlayComponent, {
        width: '500px'
      });
      localStorage.setItem('firstTimeUser', 'true')
    }

    if(localStorage.hasAcceptedPrivacy != 'true') {
      // Open the provacy police overlay
      // And when it is closed set the item 'hasAcceptedPrivacy' in localStorage to true
      // So it doens't prompt the user more times than neccesary
      this.dialog.open(PrivacyPolicyComponent, {
        width: '500px'
      }).afterClosed().subscribe(() => {
        localStorage.setItem('hasAcceptedPrivacy', 'true')
      });
    }

  }
}
